var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "nav",
      { staticClass: "space-x-10 flex border-b border-gray-300 mb-4" },
      [_vm._t("tabs")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "pr-4" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }